// rh-footer/rh-footer-block.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhFooterBlock } from '@rhds/elements/rh-footer/rh-footer-block.js';
export const FooterBlock = createComponent({
  tagName: 'rh-footer-block',
  elementClass: RhFooterBlock,
  react,
  events: {},
});
